// Side-effect module: registers the heavy `newLanding` namespace (all 14
// languages, ~90KB source) into i18next. Imported by the pages that consume
// newLanding.* keys (Landing, DirectorHome) so the payload ships with their
// lazy chunks instead of the entry bundle.
//
// Registration is idempotent and ordering-safe: per-language resources no
// longer contain a `newLanding` top-level key (see locales/index.ts), so a
// language chunk arriving after this registration cannot clobber it — the
// backend store's shallow merge preserves unrelated top-level keys.
import i18n from "../i18n";
import newLanding from "./newLanding";

for (const [code, data] of Object.entries(newLanding)) {
  i18n.addResourceBundle(code, "translation", { newLanding: data }, true, true);
}
